// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"ca62f62d","54":"12ebe50b","113":"a7a43860","255":"2cbecac1","401":"4b2c0c57","459":"4722594c","551":"d99a7505","598":"440fca8f","664":"58ef5427","761":"4920b29c","787":"f58bd7d5","796":"954aac12","988":"b0fcc8f6"}[chunkId] + ".chunk.js";
};